import { useState, useEffect } from "react";
import { loadMaterialList } from "../services/materialCategory";

const useMaterialList = () => {
    const [materialList, setMaterialList] = useState([]);
    const [selectMaterial, setSelectedMaterial] = useState(null);
    const [selectMaterialID, setSelectedMaterialID] = useState(null);
    const [isMaterialListDataLoaded, setIsMaterialListDataLoaded] = useState(false);
    const [loading, setLoading] = useState(false);

    // Fetch department data
    const fetchMaterialList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };
        setLoading(true);
        try {
            const data = await loadMaterialList(para);
            if (data && data.length > 0) {
                setMaterialList(data);
                const initialMaterial = data.find((dept) => dept.id_employee === selectedID) || [];
                if (initialMaterial) {
                    setSelectedMaterial(initialMaterial);
                    setSelectedMaterialID(initialMaterial.id_employee);
                }
                setIsMaterialListDataLoaded(true);
            }
            setLoading(false);
              return data; // ✅ THIS WAS MISSING
        } catch (error) {
            // CallMessage("error", error.message, "Error");
            setLoading(true);
              return []; // ✅ return something predictable
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialListDataLoaded) {
            fetchMaterialList();
        }
    }, [isMaterialListDataLoaded]);

  const loadMaterialListByID = async (selectedID) => {
    return await fetchMaterialList(selectedID);
};


    return {
        materialList,
        setMaterialList,
        selectMaterial,
        selectMaterialID,
        loadMaterialListByID,
        loading
    };
};

export default useMaterialList;
